import { Card, Col, Row, Table } from "antd";
import React from "react";
import { LEVELS } from "../../../store/string";
import lodash from "lodash";

const UserList = (props) => {
  // -------------------------- VAR --------------------------
  const { data, setDetail } = props;
  const levels = LEVELS;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleClick = (record) => {
    setDetail(record);
    // console.log(record)
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const columns = [
    {
      key: "username",
      dataIndex: "username",
      title: "User Name",
      render: (value) => renderUserName(value),
    },
    {
      key: "fullName",
      dataIndex: "fullName",
      title: "Full Name",
      render: (_, record) => renderFullName(record),
    },
    {
      key: "email",
      dataIndex: "email",
      title: "Email",
    },
    {
      key: "phone",
      dataIndex: "phone",
      title: "Phone",
    },
    {
      key: "DOB",
      dataIndex: "dob",
      title: "DOB",
      align: "center",
    },
    {
      key: "roster",
      dataIndex: "roster",
      title: "Roster View",
      align: "center",
      render: (_, record) => renderRoster(record),
    },
    {
      key: "active",
      dataIndex: "active",
      title: "Status",
      align: "center",
      render: (value) => renderStatus(value),
    },
    {
      key: "level",
      dataIndex: "level",
      title: "Level",
      align: "center",
      render: (_, record) => renderLevel(record),
    },
  ];

  const renderUserName = (value) => {
    const userName = value;
    return <Row>{userName}</Row>;
  };
  const renderFullName = (record) => {
    const fullName = `${record.firstName} ${record.lastName}`;
    return <Row>{fullName}</Row>;
  };

  const renderStatus = (value) => {
    const status = value ? "Active" : "Inactive";
    return <Row>{status}</Row>;
  };

  const renderRoster = (record) => {
    const individualRoster = record?.individualRoster ? "Individual" : "";
    const shopRoster = record?.shopRoster ? "Shop" : "";
    const and = individualRoster && shopRoster ? "&" : "";
    const roster = `${individualRoster} ${and} ${shopRoster}`;
    return <Row>{roster}</Row>;
  };

  const renderLevel = (record) => {
    const color = levels?.find((level) => level?.name === record?.level)?.color;
    return <Row style={{ color: color }}>{record?.level}</Row>;
  };
  // -------------------------- MAIN --------------------------
  const sorted = lodash.sortBy(data, ["firstName", "lastName"]);
  return (
    <Col span={24}>
      <Card size="small">
        <Table
          columns={columns}
          bordered={false}
          dataSource={sorted}
          pagination={false}
          size="middle"
          onRow={(record) => ({
            onClick: () => handleClick(record),
          })}
          rowKey={(record) => record?.id}
        />
      </Card>
    </Col>
  );
};
export default UserList;
